import {FC} from 'react'
import {Link} from 'react-router-dom'

const Error500: FC = () => (
  <>
    <p className='asa-error-page__code' aria-hidden='true'>
      <span className='asa-text-gradient'>۵۰۰</span>
    </p>
    <h1 className='asa-page-heading'>خطای سامانه</h1>
    <p className='asa-error-page__text'>
      مشکلی پیش آمد. تا چند لحظه دیگر به داشبورد می‌روید؛ اگر خطا تکرار شد، کمی بعد دوباره
      تلاش کنید.
    </p>
    <Link to='/dashboard' className='btn btn-primary'>
      بازگشت به داشبورد
    </Link>
  </>
)

export {Error500}
